// WebKit (Safari, en dus alle browsers op iOS) gooit een NotFoundError bij
// setPointerCapture/releasePointerCapture als de pointer net niet (meer)
// "actief" is — bij touch gebeurt dat bij elke keer loslaten. In OrbitControls
// (scans draaien) brak dat de afhandeling van het loslaten halverwege af, en
// in de dev-build ging elke aanraking ook nog door de fout-overlay. De capture
// zelf doet er dan niet toe (de vinger is al weg), dus die fout negeren we;
// andere fouten gaan gewoon door.
function guard(name) {
  const proto = typeof Element !== "undefined" ? Element.prototype : null;
  const original = proto?.[name];
  if (!original || original.__safe) return;
  const safe = function (pointerId) {
    try {
      return original.call(this, pointerId);
    } catch (err) {
      if (err?.name === "NotFoundError" || err?.name === "InvalidStateError") return undefined;
      throw err;
    }
  };
  safe.__safe = true;
  proto[name] = safe;
}

// Alleen op een touchscherm; desktop blijft zoals het was
if (typeof window !== "undefined" && window.matchMedia?.("(pointer: coarse)").matches) {
  guard("setPointerCapture");
  guard("releasePointerCapture");
}
